import { ssrApi } from 'api/ssr';
import { AllSlotsPage } from 'components/template/collection-slot';
import { ISlot } from 'constants/types';

export default function AllSlots({ slots }: { slots: ISlot[] }) {
  return <AllSlotsPage slots={slots} />;
}

export async function getServerSideProps() {
  const { results } = await ssrApi.slots.list({ limit: 12 });

  return {
    props: { slots: results },
  };
}
